import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Significance",
  "description": "",
  "published": "2007-02-02T00:00:00.000Z",
  "redirect_from": ["/blog/significance/swizec/297"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In the past humanity has regarded itself as the single most significant thing in the universe. All stars circulated us and so did all other celestial bodies. Then came alone one Nicolaus Copernicus who defined the heliocentric system and suddenly we weren't quite the most important thing in the universe as far as planetary motion went, but we were still the most important in all other aspects.`}</p>
    <p>{`Right now humanity seems to be at a stage where humans are the most developed life form in the whole known universe. To me this seems rather silly because it's based on absolutely nothing other than vanity and the feeling that we are the masters of our planet, even though we haven't explored even that fully.`}</p>
    <p>{`The thing is in mainstream science it was for a long time believed that Earth is the only place suitable for life and when all the incidents with UFOs and such came out they were pushed into hearsay and science fiction. I'm almost certain most sightings aren't aliens because when you think about it, why would aliens want to explore and befriend us? There is no reason behind it as for them to even be able to get here they would have to be far more technologically advanced and I believe humans dont' try befriending ants.`}</p>
    <p>{`Problem is that even with this idea in our heads we still only look for bacteria and even only fossil to prove there is perhaps, or once was, life outside our planet. Isn't that just a little bit pretentious? To basically be looking for proof that we're still the most significant force in the universe, yet we can't even get to another planet let alone solar system.`}</p>
    <p><a parentName="p" {...{
        "href": "http://video.google.com/videoplay?docid=-3974466981713172831"
      }}>{`This video`}</a>{`, for example, shows just how insignificant we actually are.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      